// What the book says about the game as a whole, worked out from the review
// session's state: the opening's own section draws it. Pure, so it is tested
// without React.
import type { BookReading } from '@chess/api-openings';
import { moveLabel, type ReviewState } from '@chess/api-review';
import type { BookStatus } from './BookSection.tsx';

export interface Line {
  status: BookStatus;
  reading?: BookReading;
  /** "Still in the book", "Left the book at 9. h3". */
  statusText?: string;
  /** The ply to jump to for the leaving move; undefined while still in the book. */
  leftAtPly?: number;
}

/** What the book says about the game as a whole, from the session's state. */
export function lineOf(state: ReviewState): Line {
  const game = state.game;
  if (!game) return { status: 'idle' };
  if (state.bookStatus === 'loading') return { status: 'loading' };
  if (state.bookStatus === 'unavailable') return { status: 'unavailable' };
  const reading = state.book?.reading;
  if (!reading) return { status: 'ready' };
  const stillIn = reading.lastKnownPly >= game.moves.length;
  const statusText = stillIn ? 'Still in the book' : `Left the book at ${moveLabel(game, reading.lastKnownPly + 1)}`;
  return { status: 'ready', reading, statusText, leftAtPly: stillIn ? undefined : reading.lastKnownPly };
}
